// extracted by mini-css-extract-plugin
export default {"productsSection":"productsSection_productsSection__8P8QU","productsSection_heading":"productsSection_productsSection_heading__K4fy8","navigateTo":"productsSection_navigateTo__3xHGQ"};